/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Table, Panel } from 'react-bootstrap';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import format from 'date-fns/format';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import Refresher from 'loracoms/Refresher';
import Nvl from 'loracoms/Nvl';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  parserId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
};

class ParserData extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers.data');
    this.handleReload = this.handleReload.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    const { parserId } = this.props;
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: '/lora/timeseries',
      body: { parser: parserId },
      method: 'POST',
    }).then((data) => {
      this.setState({
        timeSeries: data.list,
        status: 'success',
      });
    }).catch(() => {
      this.setState({
        status: 'failure',
      });
    });
  }

  handleReload() {
    this.loadData();
  }

  render() {
    const { pushState, appId } = this.props;
    const { timeSeries = [], status = 'pending' } = this.state;

    const dataPoints = _.uniq(_.flatMap(timeSeries, ts => _.keys(ts.metrics)));
    const ths = dataPoints.map(dp => (
      <th key={dp}>
        <Link onClick={() => pushState(`/application/${appId}/dps/${dp}/trend`)}>{dp}</Link>
      </th>
    ));
    const trs = timeSeries.map((ts, idx) => (
      <tr key={String(idx)}>
        <td>{format(ts.timestamp, 'YYYY-MM-DD HH:mm:ss')}</td>
        <td>
          <Link onClick={() => pushState(`/application/${appId}/devices/${ts.nodeid}`)}>{normalizeDevEUI(ts.nodeid)}</Link>
        </td>
        <td>
          <Nvl
            val={ts.name}
            formatter={v => (
              <Link onClick={() => pushState(`/application/${appId}/devices/${ts.nodeid}`)}>{v}</Link>
            )}
          />
        </td>
        {dataPoints.map(dp => <td key={dp}>{ts.metrics[dp]}</td>)}
      </tr>
    ));

    const header = (
      <div>
        <span>
          {this.intlMsg.msg('header')}
        </span>
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReload}
              reloading={status === 'pending'}
            />
          </li>
        </ul>
      </div>
    );

    if (timeSeries.length === 0) {
      return (
        <Panel bsStyle="aisz-white" header={header}>
          <div className={styles.noData}>
            {this.intlMsg.msg('nodata')}
          </div>
        </Panel>
      );
    }

    return (
      <Panel bsStyle="aisz-white" header={header} className="parsedDataMaxHeight">
        <Table className="aisz-table-light" striped bordered hover responsive>
          <thead>
            <tr>
              <th>
                {this.intlMsg.msg('thead.time')}
              </th>
              <th>DevEUI</th>
              <th>{this.intlMsg.msg('thead.name')}</th>
              {ths}
            </tr>
          </thead>
          <tbody>
            {trs}
          </tbody>
        </Table>
      </Panel>
    );
  }
}

ParserData.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(injectIntl(ParserData));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserData/index.jsx